import { isEmpty } from "lodash-es";
import {

  useAPIAction,
  ManageThreadsApi,
  ControlcenterMelcoModelsCreateThreadChart,
} from "melco-shared-logic";
import { useCallback } from "react";

export interface editExistingThreadDraft {
  id: string;
  threadDetail: ControlcenterMelcoModelsCreateThreadChart;
}

export const useEditThread = () => {
  const [editThread] = useAPIAction(
    ManageThreadsApi,
    async (api, threadDetail: any) => {
      //let payload = "";

      console.log(threadDetail);

      threadDetail = {
        ...threadDetail,
        presser_foot:
          threadDetail?.presser_foot && !isEmpty(threadDetail.presser_foot)
            ? [threadDetail.presser_foot].join(",")
            : "",
      };
      // call api
      let data = api.threadsUpdate({
        id: threadDetail.id,
        controlcenterMelcoModelsCreateThreadChart: threadDetail,
      });
      return {
        data,
        successMessages: [],
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "",
    }
  );

  return useCallback(
    async (threadDetails: any) => {
      return await editThread(threadDetails);
    },
    [editThread]
  );
};
